// IMPURE
const guardedSet =
  (
    key: string,
    value: string | Blob,
    additionalCheck?: (value: any) => boolean,
  ) =>
  (formData: FormData) => {
    if (value != undefined && (!additionalCheck || additionalCheck(value))) {
      formData.set(key, value);
    }
    return formData;
  };

export const formDataTrait = {
  guardedSet,
};
